module.exports = __webpack_public_path__ + "static/media/academieLyonLogo.3c76aaab.jpg";